import React from "react";
import "./Weather.css";
export default function Footer() {
  return (
    <div className="github">
      <small>
        <a
          href="https://github.com/NikaN-A/weather-app-react-master"
          target="_blank"
          rel="noreferrer"
        >
          Open-source code,
        </a>
        by Nika N
      </small>
    </div>
  );
}
